export const dineroFinanceColumns = [
    { id: "Account Number", label: "Account Number" },
    {id:"Account Name", label:"Account Name"},
    {id:"Date", label:"Date"},
    {id:"Voucher Number", label:"Voucher Number"},
    {id:"Voucher Type", label:"Voucher Type"},
    {id:"Description", label:"Description"},
    {id:"Contact Name", label:"Contact Name"},
    // {id:"ContactNumber", label:"Contact Number"},
    {id:'Contact Guid', label:'Contact Guid'},
    {id:"Vat Type", label:"VAT Type"},
    {id:"Vat Code", label:"VAT Code"},
    {id:"Amount", label:"Amount"},
    {id:"Type", label:"Type"},

    {id:"ACCID", label:"ACCID"},
    {id:"CONTID", label:"CONTID"},
    {id:"MATCHID", label:"MATCHID"},
    {id:"Bilagsnr", label:"Bilagsnr"},
    {id:"CUSTVENDID", label:"CUSTVENDID"},
    {id:"KREDIT", label:"KREDIT"},
    {id:"DEBET", label:"DEBET"},
  ];